export function PoweredBy() {
  return (
    <div class="text-center pt-0 pb-2 font-theme">
      <a
        href="https://formvue.com"
        target="_blank"
        rel="noopener"
        class="text-[11px] text-theme-muted-fg no-underline opacity-60 hover:opacity-100 transition-opacity duration-150"
      >
        Powered by <span class="font-medium">FormVue</span>
      </a>
    </div>
  );
}
